import { css } from '@eti/styles';
import { vars } from '@etg/wings';
export const cardWrapper = css`
  border: solid #e5e5e5 1px;
  display: grid;

  > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;
export const cardTitle = isButton => css`
  align-items: center;
  background: none;
  border: none;
  color: inherit;
  ${isButton ? 'cursor: pointer;' : ''}
  display: flex;
  font-size: 1rem;
  font-weight: 700;
  justify-content: space-between;
  padding-inline: 0;
`;
export const listWrapper = css`
  display: grid;
  list-style: none;

  > *:not(:last-child) {
    margin-bottom: 8px;
  }
`;
export const title = css`
  display: grid;
  font-weight: 700;
  margin-bottom: 16px;
`;
export const buttonInfo = css`
  color: ${vars.colors.signal.information.foreground};

  &:hover {
    color: ${vars.colors.signal.information.foreground};
  }

  &:active {
    color: ${vars.colors.signal.information.foreground};
  }

  &:focus-visible {
    outline: 0.125rem solid ${vars.colors.signal.information.foreground};
  }

  svg {
    height: 1.2rem;
    width: 1.2rem;
  }
`;
export const airportRow = css`
  align-content: center;
  border-radius: 5px;
  display: grid;
  min-height: 36px;
  padding: 4px 8px;

  .airportName {
    grid-area: 1 / 1 / 2 / 2;
  }

  .airportStatus {
    display: flex;
    flex-direction: row-reverse;
    justify-content: end;
  }

  .loungeName {
    display: grid;
    grid-area: 2 / 1 / 3 / 3;
    grid-column-gap: 10px;
    grid-template-columns: fit-content(100%) auto;
  }

  .loungeAccordion {
    display: grid;
    grid-area: 2 / 1 / 3 / 3;
  }

  .statusText {
    padding-inline-start: 4px;
  }
`;
export const separator = css`
  border-bottom: solid #e5e5e5 1px;
  border-top: none;
  margin-inline: -16px;
`;
export const toggleIconStyles = open => css`
  transform: rotateX(${open ? '180deg' : '0deg'});
  transition: transform 0.2s ease-in-out;
`;
//# sourceMappingURL=styles.js.map